import { Radio, RadioGroup as AriaRadioGroup } from 'react-aria-components';
import { FieldFoot, FieldLabel, cx } from './parts';
import type { RadioGroupProps } from './types';
import './styles';

/**
 * 2–5 вариантов с пояснением под названием. `variant="cards"` — карточки во
 * всю ширину (выбор режима, а не «галочка»). Стрелки двигают выбор, Tab
 * входит в группу один раз — это поведение React Aria, своей клавиатуры нет.
 */
export function RadioGroup<V extends string = string>({ label, 'aria-label': ariaLabel, explain, description, errorMessage, isInvalid, isRequired, isDisabled, className, value, onChange, options, orientation = 'vertical', variant = 'plain' }: RadioGroupProps<V>) {
  return (
    <AriaRadioGroup
      className={cx('fm-group', 'fm-field', className)}
      value={value === '' ? null : value}
      onChange={(next) => onChange(next as V)}
      orientation={orientation}
      isDisabled={isDisabled}
      isInvalid={isInvalid}
      isRequired={isRequired}
      validationBehavior="aria"
      aria-label={label ? undefined : ariaLabel}
    >
      <FieldLabel label={label} ariaLabel={ariaLabel} explain={explain} isRequired={isRequired} />
      <div className="fm-radios" data-orientation={orientation} data-variant={variant}>
        {options.map((option) => (
          <Radio key={option.id} value={option.id} isDisabled={option.isDisabled} className="fm-radio">
            <span className="fm-dot" aria-hidden="true" />
            <span className="fm-check-text">
              <span>{option.name}</span>
              {option.description ? <small>{option.description}</small> : null}
            </span>
          </Radio>
        ))}
      </div>
      <FieldFoot description={description} errorMessage={errorMessage} isInvalid={isInvalid} />
    </AriaRadioGroup>
  );
}
